import { actions } from './actions'

const initialState = {
  codigosPostales: {
    data: [],
    loading: false,
    error: '',
  },
  tiposCodigoPostal: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function codigosPostalesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CPS_LOAD_REQUESTED:
      return { ...state, codigosPostales: { ...state.codigosPostales, loading: true } }
    case actions.CPS_LOAD_SUCCEEDED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, data: action.payload, loading: false },
      }
    case actions.CPS_LOAD_FILED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: false, error: action.error },
      }
    case actions.CP_UPDATE_REQUESTED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: true, error: '' },
      }
    case actions.CP_UPDATE_SUCCEEDED:
      return {
        ...state,
        codigosPostales: {
          ...state.codigosPostales,
          data: state.codigosPostales.data.map(cp =>
            cp.id === action.payload.id ? action.payload : cp,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CP_UPDATE_FILED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: false, error: action.error },
      }
    case actions.CP_INSERT_REQUESTED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: true, error: '' },
      }
    case actions.CP_INSERT_SUCCEEDED:
      return {
        ...state,
        codigosPostales: {
          ...state.codigosPostales,
          data: [].concat(action.payload, state.codigosPostales.data),
          loading: false,
          error: '',
        },
      }
    case actions.CP_INSERT_FILED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: false, error: action.error },
      }
    case actions.CP_DELETE_REQUESTED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: true, error: '' },
      }
    case actions.CP_DELETE_SUCCEEDED:
      return {
        ...state,
        codigosPostales: {
          ...state.codigosPostales,
          data: state.codigosPostales.data.filter(cp => cp.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CP_DELETE_FILED:
      return {
        ...state,
        codigosPostales: { ...state.codigosPostales, loading: false, error: action.error },
      }
    case actions.CP_TIPOS_LOAD_REQUESTED:
      return { ...state, tiposCodigoPostal: { ...state.tiposCodigoPostal, loading: true } }
    case actions.CP_TIPOS_LOAD_SUCCEEDED:
      return {
        ...state,
        tiposCodigoPostal: { ...state.tiposCodigoPostal, data: action.payload, loading: false },
      }
    case actions.CP_TIPOS_LOAD_FILED:
      return {
        ...state,
        tiposCodigoPostal: { ...state.tiposCodigoPostal, loading: false, error: action.error },
      }
    default:
      return state
  }
}
